document.addEventListener('DOMContentLoaded', () => {
  const productsContainer = document.querySelector('[data-infinite-scroll-products]');
  const paginationInfo = document.getElementById('InfiniteScrollPagination');

  // Create a loading indicator just below the product grid
  let loadingIndicator = document.getElementById('InfiniteScrollLoading');
  if (!loadingIndicator && productsContainer) {
    loadingIndicator = document.createElement('div');
    loadingIndicator.id = 'InfiniteScrollLoading';
    loadingIndicator.textContent = 'Loading more products...';
    loadingIndicator.style.display = 'none';
    loadingIndicator.style.textAlign = 'center';
    loadingIndicator.style.padding = '16px';
    productsContainer.insertAdjacentElement('afterend', loadingIndicator);
  }

  let currentPage = 1;
  let nextPageUrl = paginationInfo ? paginationInfo.dataset.nextPageUrl : null;
  let isLoading = false;
  let hasMorePages = !!nextPageUrl;

  if (!productsContainer || !paginationInfo) return;

  const fetchProducts = async () => {
    if (isLoading || !hasMorePages || !nextPageUrl) return;

    isLoading = true;
    if (loadingIndicator) loadingIndicator.style.display = 'block';

    try {
      const response = await fetch(nextPageUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProductGrid = doc.querySelector('[data-infinite-scroll-products]');
      if (newProductGrid) {
        Array.from(newProductGrid.children).forEach(productCard => {
          // remove scroll animation classes if any
          productCard.classList.remove('scroll-trigger', 'animate--slide-in');
          productsContainer.appendChild(productCard);
        });
      }

      const newPaginationInfo = doc.getElementById('InfiniteScrollPagination');
      if (newPaginationInfo && newPaginationInfo.dataset.nextPageUrl) {
        nextPageUrl = newPaginationInfo.dataset.nextPageUrl;
        hasMorePages = true;
      } else {
        nextPageUrl = null;
        hasMorePages = false;
        if (loadingIndicator) loadingIndicator.remove();
      }

      currentPage++;
    } catch (error) {
      console.error('Error fetching more products:', error);
    } finally {
      isLoading = false;
      if (loadingIndicator) loadingIndicator.style.display = hasMorePages ? 'none' : 'none';
    }
  };

  const handleScroll = () => {
    if (isLoading || !hasMorePages) return;

    const containerBottom = productsContainer.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight;

    // Trigger when the bottom of the products grid comes within 300px of the viewport bottom
    if (containerBottom - viewportHeight <= 300) {
      fetchProducts();
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Handle the case where content is too short (auto load)
  const checkInitialLoad = () => {
    if (!isLoading && hasMorePages && productsContainer.getBoundingClientRect().bottom <= window.innerHeight) {
      fetchProducts();
    }
  };

  setTimeout(checkInitialLoad, 600);
});
